// Metodi di pagamento previsti dalla normativa italiana per registratori telematici (RT)
export const PAYMENT_METHODS = [
  { id: "cash", label: "Contanti" },
  { id: "card", label: "Carta" },
  { id: "assegno", label: "Assegno" },
  { id: "ticket", label: "Ticket / Buoni pasto" },
  { id: "non_riscosso", label: "Non riscosso / Segue fattura" },
  { id: "omaggio", label: "Omaggio" },
];

export const paymentMethodLabel = (id) =>
  PAYMENT_METHODS.find((m) => m.id === id)?.label ||
  ({ mixed: "Pagamento multiplo", bonifico: "Bonifico" }[id] || id);
